import { render, staticRenderFns } from "./Newpost.vue?vue&type=template&id=62c18856&"
import script from "./Newpost.vue?vue&type=script&lang=js&"
export * from "./Newpost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports